import { createSlice } from '@reduxjs/toolkit'
import {postCaseList, updateCaseList, getCaseByCallId,postCaseCount, setNotManaged} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';
import { convertToLocalTime } from '../../commonFunctions/commonFunctions';

const initialState= { 
  list: {
    pageIndex: 0,
    totalRecords: 50,
    totalPages: 1,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: []
  }, 
  loading: "idle",
  loadingCount: "idle",
  error: null }

const caseSlice = createSlice({
  name: 'cases',
  initialState,
  reducers: {
    clearCaseError:(state)=>{
      state.error= null
    },
    setCaseFilters:(state, action)=>{
      state.filters = action.payload;
    },
    sortList: (state, action) =>{
      state.list.elements = action.payload
    }
  },
  extraReducers: {
    [postCaseList.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [postCaseList.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      const localizedDates = action.payload.elements.map((e)=> {
        const local = {...e, creationDate: convertToLocalTime(e.creationDate), closeDate: convertToLocalTime(e.closeDate),scheduleDate: convertToLocalTime(e.scheduleDate),slaCloseDate: convertToLocalTime(e.slaCloseDate) };
        return local
      })
      state.list.elements = localizedDates 
    },
    [postCaseList.rejected]: (state, action) => {
      state.loading = "failed"; 
      state.error = action.error.message
    },
    [updateCaseList.pending]: (state) => {
      state.loading = "loading"; 
      state.error = null
    },
    [updateCaseList.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    const localizedDates = action.payload.elements.map((e)=> {
      const local = {...e, creationDate: convertToLocalTime(e.creationDate), closeDate: convertToLocalTime(e.closeDate),scheduleDate: convertToLocalTime(e.scheduleDate),slaCloseDate: convertToLocalTime(e.slaCloseDate) };
      return local
    })
    state.list.elements = localizedDates ;
    if(action.payload.errorMessage)
      state.error = action.payload.errorMessage;
    },
    [updateCaseList.rejected]: (state, action) => {
      state.loading = "succeeded";
      state.error = action.error.message
    },
    [getCaseByCallId.pending]: (state) => {
      state.loading = "loading"; 
      state.error = null
    },
    [getCaseByCallId.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.case = action.payload
    },
    [getCaseByCallId.rejected]: (state, action) => {
      state.loading = "failed"; 
      state.error = action.error.message
    },
    [postCaseCount.pending]: (state) => {
      state.loadingCount = "loading"; 
      state.error = null
    },
    [postCaseCount.fulfilled]: (state, action) => {
      state.loadingCount = "succeeded";
      state.list.pageIndex = action.payload.pageIndex;
      state.list.totalRecords = action.payload.totalRecords;
      state.list.totalPages = action.payload.totalPages;
      state.list.hasPreviousPage = action.payload.hasPreviousPage;
      state.list.hasNextPage =action.payload.hasNextPage;

    },
    [postCaseCount.rejected]: (state, action) => {
      state.loadingCount = "failed"; 
      state.error = action.error.message
    },
    [setNotManaged.pending]: (state) => {
      state.loading = "loading"; 
      state.error = null
    },
    [setNotManaged.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    const localizedDates = action.payload.elements.map((e)=> {
      const local = {...e, creationDate: convertToLocalTime(e.creationDate), closeDate: convertToLocalTime(e.closeDate),scheduleDate: convertToLocalTime(e.scheduleDate),slaCloseDate: convertToLocalTime(e.slaCloseDate) };
      return local
    })
    state.list.elements = localizedDates ;
    if(action.payload.errorMessage)
      state.error = action.payload.errorMessage;
    },
    [setNotManaged.rejected]: (state, action) => {
      state.loading = "failed"; 
      state.error = action.error.message
    },
    [logOut]: (state)=> initialState
  }
})

export const {clearCaseError, setCaseFilters, sortList} = caseSlice.actions

export default caseSlice.reducer
